import React from "react";

export class Row extends React.Component {
    render = () => (
        <div {...this.props} className={this.props.className ? "row " + this.props.className : "row"}>
            {this.props.children}
        </div>
    );
}

export class Col extends React.Component {
    render = () => (
        <div {...this.props} className={this.props.className ? "pure-u-1 " + this.props.className : "pure-u-1"}>
            {this.props.children}
        </div>
    );
}



// WEBPACK FOOTER //
// ./js/mywort/frontend/components/FoundationComponents.jsx